<script>
    export let loading = true;
    export let message = "Loading"

    export let fullscreen = true;
</script>

{#if loading}
    <div class="is-active" class:modal={fullscreen} class:inner-loader={!fullscreen}>
        <div class="lds-dual-ring"></div>
        {message}
    </div>
{:else}
    <slot></slot>
{/if}

<style>
.modal {
  background-color: #fffa;
}

.inner-loader {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #fffa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #000;
  border-color: #000 transparent #000 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>